module.exports = __webpack_public_path__ + "static/media/table2.85c8dc6e.png";